import { useAppSelector } from './useAppStore';
import { selectAdminUser } from '../store/slices/adminAuthSlice';
import { AdminRole } from '../types';

const ROLE_RANK: Record<AdminRole, number> = {
  SUPERADMIN: 4,
  ADMIN: 3,
  MODERATOR: 2,
  EDITOR: 1,
};

export function useAdminRole() {
  const admin = useAppSelector(selectAdminUser);
  const role = admin?.adminRole ?? 'EDITOR';

  const hasRole = (...roles: AdminRole[]): boolean =>
    roles.some((r) => (ROLE_RANK[role] ?? 0) >= (ROLE_RANK[r] ?? 0));

  const isSuperAdmin = role === 'SUPERADMIN';
  const isAdmin = hasRole('ADMIN');
  const isModerator = hasRole('MODERATOR');

  return { role, hasRole, isSuperAdmin, isAdmin, isModerator };
}
